export default __webpack_public_path__ + "static/media/yelpCamp4.df1f8b81.jpg";